import { useState } from "react";
import { CustomLabelInput } from "../../../../../components/input/CustomLabelInput";
import * as St from './index.styled';
import CustomBlockButton from "../../../../../components/button/CustomBlockButton";
import { CustomRatioImage } from "../../../../../components/image/CustomRatioImage";

export function WegetSearchLocation({
    addressSearchQueryDatas,
    onSetSearchQuery,
    onResetSearchQuery
}) {
    const [conditionSearchQueryDatas, setConditionSearchQueryDatas] = useState({
        productName: '',
        optionName: '',
        optionCode: '',
    });
    const [addressSearchQuery, setAddressSearchQuery] = useState('');

    const handleChangeConditionSearchQueryDatas = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        setConditionSearchQueryDatas(prev => {
            return {
                ...prev,
                [name]: value
            }
        });
    }

    const handleChangeAddressSearchQuery = (e) => {
        setAddressSearchQuery(e.target.value);
    }

    const handleSearch = (e) => {
        e.preventDefault();

        let firstSplit = addressSearchQuery?.split(' ');
        let center = '';
        let rack = '';
        let bay = '';
        let level = '';
        let position = '';

        if (firstSplit?.length === 1) {
            let secondSplit = firstSplit[0].split('-');

            if (secondSplit?.length === 4) {
                rack = (!secondSplit[0] || secondSplit[0] === '*') ? '' : secondSplit[0];
                bay = (!secondSplit[1] || secondSplit[1] === '*') ? '' : secondSplit[1];
                level = (!secondSplit[2] || secondSplit[2] === '*') ? '' : secondSplit[2];
                position = (!secondSplit[3] || secondSplit[3] === '*') ? '' : secondSplit[3];
            } else if (secondSplit?.length === 5) {
                rack = (!secondSplit[1] || secondSplit[1] === '*') ? '' : secondSplit[1];
                bay = (!secondSplit[2] || secondSplit[2] === '*') ? '' : secondSplit[2];
                level = (!secondSplit[3] || secondSplit[3] === '*') ? '' : secondSplit[3];
                position = (!secondSplit[4] || secondSplit[4] === '*') ? '' : secondSplit[4];
            }
        } else if (firstSplit?.length === 4) {
            rack = (!firstSplit[0] || firstSplit[0] === '*') ? '' : firstSplit[0];
            bay = (!firstSplit[1] || firstSplit[1] === '*') ? '' : firstSplit[1];
            level = (!firstSplit[2] || firstSplit[2] === '*') ? '' : firstSplit[2];
            position = (!firstSplit[3] || firstSplit[3] === '*') ? '' : firstSplit[3];
        } else if (firstSplit?.length === 5) {
            rack = (!firstSplit[1] || firstSplit[1] === '*') ? '' : firstSplit[1];
            bay = (!firstSplit[2] || firstSplit[2] === '*') ? '' : firstSplit[2];
            level = (!firstSplit[3] || firstSplit[3] === '*') ? '' : firstSplit[3];
            position = (!firstSplit[4] || firstSplit[4] === '*') ? '' : firstSplit[4];
        } else {
            rack = '';
            bay = '';
            level = '';
            position = '';
        }
        onSetSearchQuery({
            rack: rack.toUpperCase(),
            bay: bay.toUpperCase(),
            level: level.toUpperCase(),
            position: position.toUpperCase()
        }, conditionSearchQueryDatas);
    }

    const handleReset = () => {
        onResetSearchQuery();
        setConditionSearchQueryDatas({
            productName: '',
            optionName: '',
            optionCode: '',
        });
        setAddressSearchQuery('');
    }
    return (
        <>
            <St.SearchField.Container>
                <form onSubmit={(e) => handleSearch(e)}>
                    <St.SearchField.Wrapper>
                        <div className='box'>
                            <div className='inputBox'>
                                <CustomLabelInput>
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={addressSearchQuery || ''}
                                        onChange={(e) => handleChangeAddressSearchQuery(e)}
                                    ></CustomLabelInput.Input>
                                    <CustomLabelInput.Label>[센터 랙 베이 레벨 포지션] 와일드카드(*)</CustomLabelInput.Label>
                                </CustomLabelInput>
                                <label className='label'>로케이션 : Z-{addressSearchQueryDatas?.rack || '*'}-{addressSearchQueryDatas?.bay || '*'}-{addressSearchQueryDatas?.level || '*'}-{addressSearchQueryDatas?.position || '*'}</label>
                            </div>
                        </div>
                        <div className='box'>
                            <div className='inputBox'>
                                <CustomLabelInput>
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={conditionSearchQueryDatas?.productName || ''}
                                        name='productName'
                                        onChange={(e) => handleChangeConditionSearchQueryDatas(e)}
                                    ></CustomLabelInput.Input>
                                    <CustomLabelInput.Label>상품명</CustomLabelInput.Label>
                                </CustomLabelInput>
                            </div>
                            <div className='inputBox'>
                                <CustomLabelInput>
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={conditionSearchQueryDatas?.optionName || ''}
                                        name='optionName'
                                        onChange={(e) => handleChangeConditionSearchQueryDatas(e)}
                                    ></CustomLabelInput.Input>
                                    <CustomLabelInput.Label>옵션명</CustomLabelInput.Label>
                                </CustomLabelInput>
                            </div>
                        </div>
                        <div className='box'>
                            <div className='inputBox'>
                                <CustomLabelInput>
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={conditionSearchQueryDatas?.optionCode || ''}
                                        name='optionCode'
                                        onChange={(e) => handleChangeConditionSearchQueryDatas(e)}
                                    ></CustomLabelInput.Input>
                                    <CustomLabelInput.Label>옵션코드</CustomLabelInput.Label>
                                </CustomLabelInput>
                            </div>
                            <CustomBlockButton
                                type='submit'
                            >
                                <div className='iconFigure'>
                                    <CustomRatioImage.Figure width={1} height={1} className='figure'>
                                        <CustomRatioImage.Image src={`/assets/icons/search_000000.svg`} />
                                    </CustomRatioImage.Figure>
                                </div>
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                onClick={() => handleReset()}
                            >
                                <div className='iconFigure'>
                                    <CustomRatioImage.Figure width={1} height={1} className='figure'>
                                        <CustomRatioImage.Image src={`/assets/icons/refresh_000000.svg`} />
                                    </CustomRatioImage.Figure>
                                </div>
                            </CustomBlockButton>
                        </div>
                    </St.SearchField.Wrapper>
                </form>
            </St.SearchField.Container>
        </>
    );
}